import React, { useMemo } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import {
    OrderProductionProductInputQuery,
    useOrderProductionProductConsumedProductInputQuery,
} from '../../../../../../../../services';
import { RhSingleAutocomplete } from '../../../../../../../dum';
import { IOrderProduction } from '../../order-production-form';
import { useOrderProductionNamePrefix } from '../../order-production-name-prefix.context';
import { FIELD_LABELS, shortLabel } from '../../../../../../../../helpers';

const ARRAY_NAME: keyof IOrderProduction = 'order_production_products_consumed';
const PRODUCT_FIELD_NAME: keyof IOrderProduction['order_production_products_consumed'][number] =
    'product';

const GROUP_WEIGHT_FIELD_NAME: keyof IOrderProduction['order_production_products_consumed'][number] =
    'group_weight';
const ID_FIELD_NAME: keyof IOrderProduction = 'id';
const KILOS_FIELD_NAME: keyof IOrderProduction['order_production_products_consumed'][number] =
    'kilos';
const GROUPS_FIELD_NAME: keyof IOrderProduction['order_production_products_consumed'][number] =
    'groups';

interface IProductsInput {
    index: number;
}

export function OrderProductionProductInput({ index }: IProductsInput) {
    const prefix = useOrderProductionNamePrefix();
    const PREFIXED_ARRAY = `${prefix}${ARRAY_NAME}`;

    const id: IOrderProduction['id'] = useWatch({
        name: ID_FIELD_NAME,
    });

    const { data: productsData } = useOrderProductionProductConsumedProductInputQuery({
        variables: {
            excludeDiscontinued: !id,
        },
    });
    const INPUT_NAME = `${PREFIXED_ARRAY}.${index}.${PRODUCT_FIELD_NAME}`;
    const formContext = useFormContext();

    const filteredProducts: OrderProductionProductInputQuery['getProducts'] =
        useMemo(() => {
            return productsData?.getProducts || [];
        }, [productsData]);

    return (
        <RhSingleAutocomplete
            itemText={'compound_description'}
            itemValue={'id'}
            returnObject
            options={filteredProducts}
            name={INPUT_NAME}
            label={shortLabel(FIELD_LABELS.product_id)}
            disableGutters
            onChange={(inputValue) => {
                if (productsData && !!inputValue) {
                    const currentProduct = productsData.getProducts.find(
                        (p) => p.id === inputValue.id,
                    );
                    if (currentProduct) {
                        formContext.setValue(
                            `${PREFIXED_ARRAY}.${index}.${GROUP_WEIGHT_FIELD_NAME}`,
                            currentProduct.current_group_weight,
                        );
                        if (inputValue && currentProduct.current_group_weight) {
                            const groups =
                                (formContext.getValues(
                                    `${PREFIXED_ARRAY}.${index}.${GROUPS_FIELD_NAME}`,
                                ) as IOrderProduction['order_production_products_consumed'][number]['groups']) ||
                                0;

                            formContext.setValue(
                                `${PREFIXED_ARRAY}.${index}.${KILOS_FIELD_NAME}`,
                                groups * currentProduct.current_group_weight,
                            );
                        }
                    }
                }
            }}
        />
    );
}
